import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Logo from "../../../assets/images/Logo.png";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
  },
  borderBox: {
    position: "absolute",
    right: "5rem",
    top: "10rem",
    padding: "1rem",
    animation: "breath 3s ease-in-out infinite",
    WebkitAnimation: "breath 3s ease infinite",
    MozAnimation: "breath 3s ease infinite",
    backgroundRepeat: "no-repeat",
    boxSizing: "border-box",
    borderColor: "#996f32",
    borderStyle: "solid",
    borderWidth: "5px",
    backgroundOrigin: "padding-box, border-box",
  },
  menuDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuItems: {
    display: "flex",
    justifyContent: "flex-start",
  },
  priceItems: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});
export default function Menu() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Grid container direction="column" className={classes.bg}>
      <Grid
        item
        className={classes.borderBox}
        data-aos="flip-left"
        data-aos-duration="2000"
      >
        <ThemeProvider theme={serifFont}>
          <Typography
            variant="h6"
            paragraph
            style={{ color: "#996f32", fontStyle: "italic" }}
          >
            Bước vào bên trong Bún bò O Như, ban ngày biến thành màn đêm,
            <br />
            mùa hè sang mùa đông với nhiều bún và thịt bắp bò tươi.
          </Typography>
        </ThemeProvider>
      </Grid>
      <Grid
        item
        data-aos="fade-right"
        variant="h3"
        paragraph
        style={{
          position: "fixed",
          zIndex: 3,
          left: 0,
          top: "50%",
          padding: "1rem",
          marginLeft: "5rem",
        }}
      >
        <img src={Logo} alt="bun-bo-o-nhu-logo"></img>
      </Grid>
      <Grid
        container
        direction="column"
        style={{
          marginTop: "10rem",
          padding: "10rem",
          paddingLeft: "30rem",
          paddingRight: "10rem",
        }}
      >
        <Typography
          data-aos="fade-left"
          data-aos-duration="1000"
          variant="h3"
          style={{ fontWeight: 300, marginBottom: "2rem" }}
          gutterBottom
        >
          Thực đơn
        </Typography>
        <ThemeProvider theme={serifFont}>
          <Typography variant="h3" gutterBottom>
            MÓN CHÍNH
          </Typography>
        </ThemeProvider>
        <Grid container direction="row" className={classes.menuDiv}>
          <Grid
            item
            direction="column"
            className={classes.menuItems}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <Typography variant="h6">Tô bắp</Typography>
            <Typography variant="h6">Tô bắp gân</Typography>
            <Typography variant="h6">Tô bắp giò</Typography>
            <Typography variant="h6">Tô bắp bò viên</Typography>
            <Typography variant="h6">Tô đặc biệt</Typography>
          </Grid>
          <Grid
            item
            direction="column"
            className={classes.priceItems}
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <Typography variant="h6">35,000</Typography>
            <Typography variant="h6">45,000</Typography>
            <Typography variant="h6">45,000</Typography>
            <Typography variant="h6">45,000</Typography>
            <Typography variant="h6">55,000</Typography>
          </Grid>
        </Grid>
        <ThemeProvider theme={serifFont}>
          <Typography variant="h3" style={{ marginTop: "1rem" }} gutterBottom>
            ĂN THÊM
          </Typography>
        </ThemeProvider>
        <Grid container direction="row" className={classes.menuDiv}>
          <Grid
            item
            direction="column"
            className={classes.menuItems}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <Typography variant="h6">Chén giò</Typography>
            <Typography variant="h6">Chén bắp</Typography>
            <Typography variant="h6">Chén gân</Typography>
            <Typography variant="h6">Chén bò viên</Typography>
          </Grid>
          <Grid
            item
            direction="column"
            className={classes.priceItems}
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <Typography variant="h6">20,000</Typography>
            <Typography variant="h6">20,000</Typography>
            <Typography variant="h6">20,000</Typography>
            <Typography variant="h6">20,000</Typography>
          </Grid>
        </Grid>
        <ThemeProvider theme={serifFont}>
          <Typography variant="h3" style={{ marginTop: "1rem" }} gutterBottom>
            GIẢI KHÁT
          </Typography>
        </ThemeProvider>
        <Grid container direction="row" className={classes.menuDiv}>
          <Grid
            item
            direction="column"
            className={classes.menuItems}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <Typography variant="h6">Nước suối</Typography>
            <Typography variant="h6">Nước ngọt</Typography>
            <Typography variant="h6">Chanh xả mật ong</Typography>
            <Typography variant="h6">Trà đá</Typography>
          </Grid>
          <Grid
            item
            direction="column"
            className={classes.priceItems}
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <Typography variant="h6">12,000</Typography>
            <Typography variant="h6">15,000</Typography>
            <Typography variant="h6">12,000</Typography>
            <Typography variant="h6">2,000</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
